module.exports = __webpack_public_path__ + "static/img/pinpai-6.19dc59f8.png";